import React, { useState, useEffect } from "react";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { ProgramFilter, ReportFilterBar } from '../ReportFilters';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";

export default function CustomerContactsReport(props) {
    const defaultGridId = 73;
    const [gridId, setGridId] = useState(props.customReportGridId || defaultGridId);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [isFavorite, setIsFavorite] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);

        // axios
        //     .get(APIURL + "/jsreport/getAllReports", {
        //         params: { empID: props.user.emp_id },
        //     })
        //     .then((response) => {
        //         const report = response?.data?.reports.find((ele) => ele.report_name === "Active Customer Report");
        //         setReportDetails(report);
        //         setIsFavorite(report ? (report.status === 1 ? true : false) : false);
        //     });

        axios
            .get(APIURL + "/reports/getCustomerContacts", {
                params: {
                    com_id: props.user.comp_id,
                    emp_id: props.user.emp_id,
                    program_id: selectedProgram || undefined,
                },
            })
            .then((response) => {
                setData(response?.data.length !== 0 ? response?.data : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    };

    const columns = [
        { field: "con_first_name", headerName: "Contact First Name", flex: 1 },
        { field: "con_last_name", headerName: "Contact Last Name", flex: 1 },
        { field: "con_address", headerName: "Contact Address", flex: 1 },
        { field: "con_phone", headerName: "Contact Phone", flex: 1 },
        { field: "con_designation", headerName: "Contact Designation", flex: 1 },
        { field: "con_contact_type", headerName: "Contact Type", flex: 1 },
        { field: "con_email", headerName: "Contact Email", flex: 1 },
    ]

    const rows = data.map((data, index) => {
        const instance = {
            hierarchy: [data.cus_name, `${data.con_id}${data.pro_id ? ` - ${data.pro_id}` : ''}`],
            id: index,
            con_id: data.con_id,
            con_first_name: data.con_first_name,
            con_last_name: data.con_last_name,
            con_address: [data.con_Addr_line1, data.con_Addr_line2, data.con_city, data.con_state, data.con_zip].filter(Boolean).join(', '),
            con_phone: data.con_phone,
            con_designation: data.con_designation,
            con_contact_type: data.con_contact_type,
            con_email: data.con_email,
        };
        return instance;
    });

    // const markFavourite = async (data, type) => {
    //     const payload = {
    //         report_id: data?.report_id,
    //         status: type,
    //         empID: props.user.emp_id
    //     };

    //     axios
    //         .put(APIURL + "/jsreport/markFavorite", payload)
    //         .then((response) => {
    //             if (response?.status === 200 && response?.data?.code === 200) {
    //                 setSuccessText(response?.data?.status_message || "Favorite Modifed Succesfully");
    //             } else {
    //                 setErrorText("Something went wrong");
    //             }

    //             fetchData();
    //         });
    // }

    return (
        <div style={{ margin: 0, width: '100%', padding: 10, boxSizing: 'border-box' }}>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div />
                <Tooltip title={isFavorite ? "Remove from favorite reports" : "Add to favorite reports"}>
                    <img
                        src={isFavorite ? "./star-solid.svg" : "./star-regular.svg"}
                        alt="barchart"
                        style={{
                            fontFamily: "Lato",
                            width: "1.5rem",
                            height: "1.5rem",
                            cursor: "pointer",
                            margin: 5
                        }}
                        onClick={() => markFavourite(reportDetails, isFavorite ? 0 : 1)}
                    />
                </Tooltip>
            </div> */}
            <ReportFilterBar onSearch={() => fetchData()} style={{ marginBottom: 10 }}>
                <ProgramFilter
                    comp_id={props.user.comp_id}
                    value={selectedProgram}
                    onChange={setSelectedProgram}
                />
            </ReportFilterBar>
            <div style={{ height: 'calc(100vh - 250px)' }}>
                <DataGridPro
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    disableRowSelectionOnClick
                    treeData
                    getTreeDataPath={(row) => row.hierarchy}
                    groupingColDef={{ headerName: 'Customer Name' }}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 1 ? 'report-row-alternate' : ''
                    }
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.2,
                            textAlign: 'left',
                            wordBreak: 'break-word',
                            maxWidth: '100%',
                        },
                        '& .report-row-alternate .MuiDataGrid-cell, & .report-row-alternate .MuiDataGrid-filler--pinnedLeft': {
                            backgroundColor: '#EAF4FC',
                        },
                        '& .report-row-alternate:hover .MuiDataGrid-cell, & .report-row-alternate:hover .MuiDataGrid-filler--pinnedLeft': {
                            backgroundColor: '#DCEFFC',
                        },
                    }}
                    loading={isLoading}
                    showToolbar />
            </div>
        </div>
    );
}
